import type { Container } from 'pixi.js';
import { Circle, Ellipse, Polygon, Rectangle, RoundedRectangle } from 'pixi.js';
import type { HitArea } from './types/hitArea';
import { HitAreaType } from './types/hitArea';

export function setHitArea(view: Container, hitArea?: HitArea): void {
  if (!hitArea || hitArea.type === HitAreaType.None) {
    view.hitArea = null;
    return;
  }

  switch (hitArea.type) {
    case HitAreaType.Rectangle:
      view.hitArea = new Rectangle(hitArea.x, hitArea.y, hitArea.width, hitArea.height);
      break;

    case HitAreaType.Circle:
      view.hitArea = new Circle(hitArea.x, hitArea.y, hitArea.radius);
      break;

    case HitAreaType.Ellipse:
      view.hitArea = new Ellipse(hitArea.x, hitArea.y, hitArea.halfWidth, hitArea.halfHeight);
      break;

    case HitAreaType.Polygon:
      view.hitArea = new Polygon(hitArea.path.split(/\s*,\s*/).map(Number));
      break;

    case HitAreaType.RoundedRectangle:
      view.hitArea = new RoundedRectangle(hitArea.x, hitArea.y, hitArea.width, hitArea.height, hitArea.radius);
      break;

    default:
      break;
  }
}
